import { render, staticRenderFns } from "./UserNavigation.vue?vue&type=template&id=2d2fdd44&scoped=true&"
import script from "./UserNavigation.vue?vue&type=script&lang=js&"
export * from "./UserNavigation.vue?vue&type=script&lang=js&"
import style0 from "./UserNavigation.vue?vue&type=style&index=0&id=2d2fdd44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2fdd44",
  null
  
)

export default component.exports